export default "__VITE_ASSET__BGqWyjsH__"